import { makeStyles } from '@material-ui/core/styles'

export const myAlertsStyles = makeStyles((theme) => ({
  container: {
    padding: 0,
    margin: 0,
    width: 335,
    overflowY: 'clip',
    overflowX: 'hidden',
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  retainer: {
    height: '100%',
  },
  modalTabs: {
    width: '335px',
    height: '35px',
    minHeight: '35px',
    minWidth: '335px',
    [theme.breakpoints.down(400)]: {
      width: '300px',
    },
  },
  alertsListContainer: {
    padding: theme.spacing(0.5),
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  alertsListContainerHistory: {
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  alertListHeight: {
    display: 'block',
    height: 391,
    maxHeight: 391,
    overflowY: 'auto',
    borderBottom: `1px solid ${theme.palette.base.lightGray}`,
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 283px)',
    },
  },
  alertListHighChip: {
    background: theme.palette.base.red,
    color: theme.palette.base.white,
    fontSize: '1rem',
    '&:hover': {
      background: theme.palette.base.red,
    },
  },
  alertListMediumChip: {
    background: theme.palette.base.blue,
    color: theme.palette.base.white,
    fontSize: '1rem',
    '&:hover': {
      background: theme.palette.base.blue,
    },
  },
  alertListLowChip: {
    background: theme.palette.base.yellow,
    color: theme.palette.base.black,
    fontSize: '1rem',
    '&:hover': {
      background: theme.palette.base.yellow,
    },
  },
  fullWidth: {
    maxWidth: '100% !important',
  },
  pastHistoryButton: {
    width: 'calc(100% - 8px)',
    background: theme.palette.base.rutgersRed,
    color: theme.palette.base.white,
    height: 44,
    fontSize: '1rem',
    margin: theme.spacing(0.5),
  },
  icon: {
    borderLeft: '5px solid red',
  },
}))

export default myAlertsStyles
